<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div class="loading" v-if="processando">
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="col-md-12">
            <div class="row row-margin">
              <div class="col-md-12">
                <strong>Periodo: </strong> De: {{dadosAnalise.dataInicial}} até {{dadosAnalise.dataFinal}}
              </div>
            </div>
            <div class="row row-margin">
              <div class="col-md-6">
                <strong>Veículo: </strong> {{dadosAnalise.veiculo}}
              </div>
              <div class="col-md-6">
                <strong>Empresa: </strong>{{dadosAnalise.empresa}}
              </div>
            </div>
            <div class="row row-margin">
              <div class="col-md-4">
                <strong>Distância Percorrida: </strong>{{parseFloat(dadosAnalise.kmRodados).toFixed(2)}} Km 
              </div>
              <div class="col-md-4">
                <strong>Velocidade Média: </strong>{{parseFloat(dadosAnalise.velocidadeMedia).toFixed(2)}} Km/h
              </div>
                <div class="col-md-4">
                <strong>Velocidade Máxima: </strong>{{parseFloat(dadosAnalise.velocidadeMaxima).toFixed(2)}} Km/h 
              </div>
            </div>
            <div class="row row-margin">
              <div class="col-md-4">
                <label><input type="checkbox" id="checkbox" v-model="inicioJornadaManual"> Informar inicio de Jornada Manual</label>
                <template v-if="inicioJornadaManual">
                  <br>
                  <strong>Data hora Inicial Jornada: </strong>
                  <input-data-hora-picker v-model="dataHoraInicialJornadaManual" class="form-control pula data" />
                </template>
              </div>
              <div class="col-md-4">
                <label><input type="checkbox" id="checkbox" v-model="finalJornadaManual"> Informar final de Jornada Manual</label>
                <template v-if="finalJornadaManual">
                  <br>
                  <strong>Data hora Final Jornada: </strong>
                  <input-data-hora-picker v-model="dataHoraFinalJornadaManual" class="form-control pula data" />
                </template>
              </div>
              <div class="col-md-4">
                <strong>Motorista: </strong>{{dadosAnalise.motorista}}
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row row-margin">
              <div class="col-md-4">
                <div>
                  <strong>Problemas encontrados na Análise</strong>
                  <div class="description" v-html="dadosAnaliseProblemas"></div>
                </div>
              </div>
              <div class="col-md-4">
              </div>
              <div class="col-md-4">
                <div class="pull-right">
                  <button id="gravarAnalise" type="button" class="btn btn-success " v-on:click="gravarAnalise" >
                    <span class="glyphicon glyphicon-save" aria-hidden="true"></span> Gravar Análise
                  </button>
                </div>
              </div>
            </div>
          </div>

          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>HORA</th>
                <th>MACRO</th>
              </tr>
            </thead>
            <tbody v-for="(grid, i) in dadosAnaliseMacros" >
              <tr>
                <td>{{grid.dataHoraInicio}}</td>
                <td>{{grid.macro}}</td>
              </tr>
            </tbody>
          </table>

          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>PERIODO</th>
                <th>DURAÇÃO</th>
                <th></th>
                <th>MOTIVO</th>
                <th>TIPO</th>
                <th>OBSERVAÇÃO</th>
              </tr>
            </thead>
            <tbody v-for="(grid, i) in dadosAnalise.dados" >
              <template v-if="i > 0 && dadosAnalise.dados[i].data !== dadosAnalise.dados[i-1].data">
                <tr style="background-color: #FF0400; height: 20px"><td colspan="6"></td></tr>
              </template>
              <tr v-bind:class="{ 'gestao-jornada-atencao': (grid.statusVeiculo === 'VEICULO PARADO' && grid.motivo === '') }">
                <td width="140"><small>{{grid.data}} {{grid.dataHoraInicio}}<br>{{grid.data}} {{grid.dataHoraFinal}}</small></td>
                <td width="85"><small>{{grid.dataHoraDuracao}}</small></td>
                <td><small>{{grid.statusVeiculo}}</small>
                  <template v-if="grid.statusVeiculo === 'VEICULO EM MOVIMENTO'">
                    <small> - {{formatarVelocidadeMetros(grid.kmRodados)}} metros </small>
                  </template>
                </td>
                <td><small>{{grid.motivo}}</small></td>
                <td><small>{{grid.tipoMotivo}}</small></td>
                <!-- <td>{{grid.movimentoSecundario}}</td> -->
                <td><small class="text-muted">{{grid.observacao}}</small></td>
                <!-- <td>{{latitude}}</td>
                <td>{{longitude}}</td>
                <td>{{icone}}</td>
                <td>{{kmRodados}}</td>
                <td>{{velocidadeMaxima}}</td>
                <td>{{velocidadeMedia}}</td>
                <td>{{alerta}}</td>
                <td>{{error}}</td>
                <td>{{automatico}}</td>
                <td>{{mudouDia}}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div> 
    </div>                               
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      inicioJornadaManual: false,
      finalJornadaManual: false,
      dataHoraInicialJornadaManual: '',
      dataHoraFinalJornadaManual: '',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosAnalise: [],
      dadosAnaliseMacros: [],
      dadosAnaliseProblemas: '',
      processando: false,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false
    }
  },
  mounted () {
    // this.buscarVeiculos()
    this.gerarAnalise()
  },
  methods: {
    selecionarItem: function (item) {
      console.log(item.id)
      this.selecionada = item.idVeiculo
    },
    selecionado: function (item) {
      return this.selecionada === item.idVeiculo
    },
    setarVeiculo: function (veiculo) {
      this.model.veiculoId = veiculo.id
      this.model.veiculoDescricao = veiculo.descricaoVeiculo
      $(this.$el).find('#veiculoDescricao').val(veiculo.descricaoVeiculo)
    },
    verificarVeiculo: function () {
      if ($(this.$el).find('#veiculoId').val() === '0') {
        this.veiculoId = 0
        this.veiculoDescricao = ''
        $(this.$el).find('#veiculoId').val(0)
        $(this.$el).find('#veiculoDescricao').val('')
      }
      if ($(this.$el).find('#veiculoDescricao').val() === '') {
        this.veiculoId = 0
        this.veiculoDescricao = ''
        $(this.$el).find('#veiculoId').val(0)
        $(this.$el).find('#veiculoDescricao').val('')
      }
    },
    gerarAnalise: function () {
      var self = this
      self.processando = true
      var veiculoId = this.$route.params.veiculo
      var dataHoraInicial = this.$route.params.dataInicial.replace(/-/g, '/')
      var dataHoraFinal = this.$route.params.dataFinal.replace(/-/g, '/')
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/analiseJornadas?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosAnalise = dadosCadastro
        self.dadosAnaliseMacros = dadosCadastro.dadosMacros
        self.dadosAnaliseProblemas = dadosCadastro.problemasEncontrados
        self.processando = false
      })
    },
    gravarAnalise: function () {
      var self = this
      var veiculoId = this.$route.params.veiculo
      var dataHoraInicial = this.$route.params.dataInicial.replace(/-/g, '/')
      var dataHoraFinal = this.$route.params.dataFinal.replace(/-/g, '/')
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      if (self.inicioJornadaManual === true) {
        if (self.dataHoraInicialJornadaManual === '') {
          self.$toastr('error', 'Preencha a Data Inicial da Jornada', 'Atenção')
          return
        }
      }
      if (self.finalJornadaManual === true) {
        if (self.dataHoraFinalJornadaManual === '') {
          self.$toastr('error', 'Preencha a Data Final da Jornada', 'Atenção')
          return
        }
      }
      self.processando = true
      var url = '/api/analiseJornadasGravar?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal
      if (self.inicioJornadaManual === true) {
        url = url + '&dataHoraInicialJornada=' + self.dataHoraInicialJornadaManual
      }
      if (self.finalJornadaManual === true) {
        url = url + '&dataHoraFinalJornada=' + self.dataHoraFinalJornadaManual
      }
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosAnalise = dadosCadastro
        self.dadosAnaliseMacros = dadosCadastro.dadosMacros
        self.dadosAnaliseProblemas = dadosCadastro.problemasEncontrados
        self.processando = false
        self.$router.replace('/gestaoJornada')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/jornadas/AnaliseJornadasView.vue